import { AlertTriangle } from 'lucide-react'

const SkipConfirmDialog = ({ confirmLabel, declined = false, isPending, onConfirm, onCancel }) => {
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ background: 'rgba(15, 23, 42, 0.75)', backdropFilter: 'blur(4px)' }}
        >
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">

                <div className="px-7 pt-8 pb-6 text-center">
                    <div className="flex justify-center mb-5">
                        <div className="w-16 h-16 rounded-full bg-amber-50 border border-amber-200 flex items-center justify-center">
                            <AlertTriangle className="w-8 h-8 text-amber-500" />
                        </div>
                    </div>

                    <h2 className="text-xl font-bold text-gray-800 mb-2">
                        Are you sure?
                    </h2>
                    <p className="text-gray-600 text-sm leading-relaxed">
                        Completing the identity verification is the fastest and most reliable
                        way for us to confirm your details. {declined ? (
                            <>Please only continue if you do not want to share your <strong className="font-semibold text-gray-900">non-expired</strong> US ID card.</>
                        ) : (
                            <>Please only continue if you genuinely do not have a <strong className="font-semibold text-gray-900">non-expired</strong> US ID card to provide.</>
                        )}
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 px-7 pb-7">
                    <button
                        type="button"
                        onClick={onCancel}
                        disabled={isPending}
                        className="w-full sm:flex-1 py-3 rounded-xl text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 active:scale-[0.98] transition-all disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                        Go back & verify
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={isPending}
                        className="w-full sm:flex-1 py-3 rounded-xl text-sm font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 active:scale-[0.98] transition-all disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                        {confirmLabel || 'Skip'}
                    </button>
                </div>

            </div>
        </div>
    )
}

export default SkipConfirmDialog
